import { render, staticRenderFns } from "./land-owners.vue?vue&type=template&id=0849a16d"
import script from "./land-owners.vue?vue&type=script&lang=js"
export * from "./land-owners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScriptLoader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/script-loader/ScriptLoader.vue').default,Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,Iframe: require('/home/runner/work/platform/platform/packages/client/src/components/elements/content-editor/iframe.js').default,Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
